import React from "react";
import Pricing from "../Pricing";

export default function HomePricing() {
  return <Pricing />;
}
